"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowBack = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var defaultSize = 14;

function ArrowBack(_a) {
  var children = _a.children,
      _b = _a.size,
      size = _b === void 0 ? defaultSize : _b,
      props = tslib_1.__rest(_a, ["children", "size"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    width: "".concat(size / 16, "rem"),
    height: "".concat(size / 16, "rem"),
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    d: "M5.11554 9.05244C4.99038 8.92762 4.91988 8.75821 4.91954 8.58144V8.24344C4.92195 8.06739 4.99215 7.89905 5.11554 7.77345L9.68454 3.21344C9.72583 3.17175 9.77497 3.13865 9.82912 3.11607C9.88328 3.09348 9.94137 3.08185 10 3.08185C10.0587 3.08185 10.1168 3.09348 10.171 3.11607C10.2251 3.13865 10.2743 3.17175 10.3155 3.21344L10.9465 3.84344C10.9878 3.88403 11.0207 3.93243 11.043 3.98582C11.0654 4.03922 11.077 4.09654 11.077 4.15444C11.077 4.21235 11.0654 4.26967 11.043 4.32307C11.0207 4.37646 10.9878 4.42486 10.9465 4.46545L6.99154 8.41245L10.9465 12.3594C10.9881 12.4007 11.0211 12.4498 11.0436 12.5038C11.0661 12.5579 11.0776 12.6159 11.0776 12.6744C11.0776 12.733 11.0661 12.791 11.0436 12.845C11.0211 12.8991 10.9881 12.9482 10.9465 12.9894L10.3155 13.6124C10.2743 13.6541 10.2251 13.6872 10.171 13.7098C10.1168 13.7324 10.0587 13.744 10 13.744C9.94137 13.744 9.88328 13.7324 9.82912 13.7098C9.77497 13.6872 9.72583 13.6541 9.68454 13.6124L5.11554 9.05244V9.05244Z",
    fill: "currentColor"
  }));
}

exports.ArrowBack = ArrowBack;